module.exports = __webpack_public_path__ + "static/media/unlink.2118ccac.png";